export default __webpack_public_path__ + "static/media/customerappointments.ea33bc38.png";